import { render, staticRenderFns } from "./deleteModel.vue?vue&type=template&id=8536b530&scoped=true&"
import script from "./deleteModel.vue?vue&type=script&lang=js&"
export * from "./deleteModel.vue?vue&type=script&lang=js&"
import style0 from "./deleteModel.vue?vue&type=style&index=0&id=8536b530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8536b530",
  null
  
)

export default component.exports